<template>
    <div>
        <div>
            <div class="form-group row">
                <div class="col-sm-12 col-md-12 col-lg-9">
                    <div v-if="confTimezone == 1" class="row">
                        <div class="col-12 col-sm-6">
                            <div class="mb-3">
                                <label for="timezone">タイムゾーン設定</label>
                                <div class="form-group mt-0 mb-1">
                                    <div class="form-check form-check-inline">
                                        <input
                                            v-model="doctor.is_device_timezone"
                                            type="checkbox"
                                            id="is_device_timezone"
                                            class="form-check-input"
                                            @change="syncDeviceTimezone">
                                        <label
                                            for="is_device_timezone"
                                            class="mb-0">
                                            デバイスのタイムゾーンに合わせる
                                        </label>
                                    </div>
                                </div>
                                <select
                                    v-model="doctor.timezone"
                                    :disabled="doctor.is_device_timezone == 1"
                                    id="timezone"
                                    class="form-control"
                                    :class="{ 'is-invalid' : errors.timezone }">
                                    <option value="">選択してください</option>
                                    <option
                                        v-for="timezone in timezones"
                                        :value="timezone.key">
                                        {{ timezone.value }}
                                    </option>
                                </select>
                                <div v-if="errors.timezone"
                                     class="invalid-feedback d-block">
                                    {{ errors.timezone[0] }}
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-12 col-sm-6">
                            <div class="mb-3">
                                <label for="last_name">姓</label>

                                <input
                                    v-model="doctor.last_name"
                                    type="text"
                                    id="last_name"
                                    class="form-control"
                                    :class="{ 'is-invalid' : errors.last_name }"
                                    placeholder="姓">

                                <div
                                    v-if="errors.last_name"
                                    class="invalid-feedback d-block">
                                    {{ errors.last_name[0] }}
                                </div>
                            </div>
                        </div>

                        <div class="col-12 col-sm-6">
                            <div class="mb-3">
                                <label for="first_name">名</label>

                                <input
                                    v-model="doctor.first_name"
                                    type="text"
                                    id="first_name"
                                    class="form-control"
                                    :class="{ 'is-invalid' : errors.first_name }"
                                    placeholder="名">

                                <div
                                    v-if="errors.first_name"
                                    class="invalid-feedback d-block">
                                    {{ errors.first_name[0] }}
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-12 col-sm-6">
                            <div class="mb-3 mb-0-sm">
                                <label for="last_name_kana">セイ</label>

                                <input
                                    v-model="doctor.last_name_kana"
                                    type="text"
                                    id="last_name_kana"
                                    class="form-control"
                                    :class="{ 'is-invalid' : errors.last_name_kana }"
                                    placeholder="セイ">

                                <div
                                    v-if="errors.last_name_kana"
                                    class="invalid-feedback d-block">
                                    {{ errors.last_name_kana[0] }}
                                </div>
                            </div>
                        </div>

                        <div class="col-12 col-sm-6">
                            <div class="mb-3 mb-0-sm">
                                <label for="first_name_kana">メイ</label>

                                <input
                                    v-model="doctor.first_name_kana"
                                    type="text"
                                    id="first_name_kana"
                                    class="form-control"
                                    :class="{ 'is-invalid' : errors.first_name_kana }"
                                    placeholder="メイ">

                                <div
                                    v-if="errors.first_name_kana"
                                    class="invalid-feedback d-block">
                                    {{ errors.first_name_kana[0] }}
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-12 col-sm-6">
                            <div class="mb-3">
                                <label for="postcode">郵便番号</label>

                                <div class="input-group">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text">〒</span>
                                    </div>

                                    <input
                                        v-model="doctor.postcode"
                                        @change="changePostcode"
                                        type="text"
                                        id="postcode"
                                        class="form-control"
                                        :class="{ 'is-invalid' : errors.postcode }"
                                        placeholder="000-1111">

                                    <div
                                        v-if="errors.postcode"
                                        class="invalid-feedback d-block">
                                        {{ errors.postcode[0] }}
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="col-12 col-sm-6">
                            <div class="mb-3">
                                <label for="prefecture">都道府県</label>

                                <select
                                    v-model="doctor.prefecture"
                                    id="prefecture"
                                    class="form-control"
                                    :class="{ 'is-invalid' : errors.prefecture }">

                                    <option :value="null">選択してください</option>
                                    <option v-for="pref in prefmap" :value="pref">
                                        {{ pref }}
                                    </option>
                                </select>

                                <div
                                    v-if="errors.prefecture"
                                    class="invalid-feedback d-block">
                                    {{ errors.prefecture[0] }}
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-12 col-sm-6">
                            <div class="mb-3">
                                <label for="address">市区町村・番地</label>

                                <input
                                    v-model="doctor.address"
                                    type="text"
                                    id="address"
                                    class="form-control"
                                    :class="{ 'is-invalid' : errors.address }"
                                    placeholder="市区町村・番地">

                                <div
                                    v-if="errors.address"
                                    class="invalid-feedback d-block">
                                    {{ errors.address[0] }}
                                </div>
                            </div>
                        </div>

                        <div class="col-12 col-sm-6">
                            <div class="mb-3">
                                <label for="building">建物名など</label>

                                <input
                                    v-model="doctor.building"
                                    type="text"
                                    id="building"
                                    class="form-control"
                                    :class="{ 'is-invalid' : errors.building }"
                                    placeholder="建物名など">

                                <div
                                    v-if="errors.building"
                                    class="invalid-feedback d-block">
                                    {{ errors.building[0] }}
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-12 col-sm-6">
                            <div>
                                <label for="tel">電話番号<span class="small">（滞在している国の国際番号）</span></label>
                                <vue-tel-input
                                    v-model="doctor.tel"
                                    id="tel"
                                    name="tel"
                                    :class="{ 'is-invalid' : errors.tel || telObj.valid === false }"
                                    placeholder="000-1111-2222"
                                    valid-characters-only
                                    default-country="JP"
                                    @validate="onValidateTel">
                                </vue-tel-input>
                                <div v-if="errors.tel" class="invalid-feedback d-block">{{ errors.tel[0] }}</div>
                                <div v-if="telObj.valid === false" class="invalid-feedback d-block">電話番号を正しく入力してください</div>
                            </div>
                            <div
                                v-if="$locale.type === 'consul'"
                                class="form-group mt-1">
                                <div class="form-check form-check-inline">
                                    <input
                                        v-model="doctor.doctor_metadata.is_sms_consultation_authorized"
                                        type="checkbox"
                                        id="is_sms_consultation_authorized"
                                        class="form-check-input">
                                    <label
                                        for="is_sms_consultation_authorized"
                                        class="mb-0">
                                        予約確定時に電話番号宛にSMSを送信する
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-12">
                            <div class="mb-3">
                                <label for="introduction">自己紹介文</label>

                                <textarea
                                    v-model="doctor.introduction"
                                    id="introduction"
                                    class="form-control"
                                    :class="{ 'is-invalid' : errors.introduction }"
                                    rows="6"
                                    placeholder="自己紹介文を入力">
                                </textarea>

                                <div
                                    v-if="errors.introduction"
                                    class="invalid-feedback d-block">
                                    {{ errors.introduction[0] }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="col-sm-6 col-md-6 col-lg-3">
                    <label>プロフィール画像</label>

                    <div id="c-upload" class="c-upload">
                        <div v-if="image.base64 !== null"
                             class="c-upload__image">

                            <div class="c-upload__delete d-none"
                                 :class="{ 'd-flex justify-content-center align-items-center' : image.base64 }">
                                <label class="btn btn-sm btn-danger"
                                       @click="prepareDeleteImage">
                                    画像を削除
                                </label>
                            </div>

                            <img :src="image.base64">
                        </div>

                        <div
                            v-else-if="doctor.image_url"
                            class="c-upload__image">
                            <div
                                class="c-upload__delete d-none"
                                :class="{ 'd-flex justify-content-center align-items-center' : doctor.presigned_url }">
                                <label
                                    class="btn btn-sm btn-danger"
                                    @click="prepareDeleteImage">
                                    画像を削除
                                </label>
                            </div>
                            <img :src="doctor.presigned_url">
                        </div>
                        <div
                            v-else
                            class="c-upload__image">
                            <img src="/images/common/profile_default.svg">
                        </div>

                        <div class="input-group input-profile-image-wrapper mt-2">
                            <b-form-file
                                v-model="image.object"
                                ref="fileinput"
                                placeholder="画像をアップロード"
                                accept="image/jpeg, image/png, image/gif"
                                :class="{ 'is-invalid' : errors.profile_image }"
                                @change="bindSelectedImage">
                            </b-form-file>
                        </div>
                    </div>

                    <div v-if="errors.profile_image"
                         class="invalid-feedback d-block">
                        {{ errors.profile_image[0] }}
                    </div>
                </div>
            </div>

            <div class="text-right">
                <button
                    :disabled="telObj.valid === false || inProgress"
                    @click="updateProfile"
                    class="btn btn-yokumiru-orange">
                    プロフィールを更新
                </button>
            </div>
        </div>
    </div>
</template>

<script>
    import constants from '../../constants'
    import moment from 'moment-timezone'

    export default {
        props: {
            dataDoctor: {
                type: Object,
                default: {},
            },
            medicalCourses: {
                type: Array,
                default: {},
            },
            confTimezone: {
                type: Number,
                required: true,
            },
        },

        data: function () {
            return {
                doctor: null,
                image: {
                    name: null,
                    object: null,
                    base64: null,
                },
                prefmap: [
                    '北海道', '青森県', '岩手県', '宮城県',
                    '秋田県', '山形県', '福島県', '茨城県', '栃木県',
                    '群馬県', '埼玉県', '千葉県', '東京都', '神奈川県',
                    '新潟県', '富山県', '石川県', '福井県', '山梨県',
                    '長野県', '岐阜県', '静岡県', '愛知県', '三重県',
                    '滋賀県', '京都府', '大阪府', '兵庫県', '奈良県',
                    '和歌山県', '鳥取県', '島根県', '岡山県', '広島県',
                    '山口県', '徳島県', '香川県', '愛媛県', '高知県',
                    '福岡県', '佐賀県', '長崎県', '熊本県', '大分県',
                    '宮崎県', '鹿児島県', '沖縄県',
                ],
                timezones: [],
                telObj: {},
                errors: {},
                inProgress: false,
            };
        },

        created: async function () {
            this.doctor = this.dataDoctor

            await this.fetchTimezones()
            this.syncDeviceTimezone()
        },

        methods: {
            syncDeviceTimezone: function () {
                if (this.doctor.is_device_timezone == 1) {
                    const browserZone = moment.tz.guess()

                    this.timezones.forEach((timezone) => {
                        if (timezone.key === browserZone) {
                            this.doctor.timezone = browserZone
                        }
                    })
                }
            },

            onValidateTel: function (object) {
                if (object.number.input) {
                    this.telObj = object
                }
                else {
                    this.telObj = {
                        number: { e164: null, national: null },
                        valid: true,
                        regionCode: null,
                    }
                }
            },

            /**
             * 郵便番号入力時
             */
            changePostcode: function () {
                let postcode = this.doctor.postcode;
                postcode = postcode.replace('-', '');

                axios.get(`${constants.doctor.zip.endpoint.base}?postcode=${postcode}`)
                    .then(({data}) => {
                        try {
                            let newPrefecture = data.data[0].ja.prefecture;
                            let newAddress = data.data[0].ja.address1 + data.data[0].ja.address2 + data.data[0].ja.address3 + data.data[0].ja.address4;
                            this.doctor.prefecture = newPrefecture;
                            this.doctor.address = newAddress;
                        } catch (e) {
                            this.doctor.prefecture = "";
                            this.doctor.address = "";
                            console.log('__YokumiruAPI__ : 住所情報の取得に失敗しました。');
                        }
                    });
            },

            /**
             * 画像選択時処理
             *
             * @return {void}
             */
            bindSelectedImage: function (e) {
                const elem = e.target

                this.errors = {}

                if (elem.files.length > 0) {
                    if (elem.files[0].size > 10240000) {
                        this.errors = { profile_image: ['画像のファイルサイズは10MB以内にしてください。'] }
                        return
                    }

                    this.image.object = elem.files[0]
                    this.image.name = this.image.object.name

                    const fr = new FileReader()
                    fr.onload = () => { this.image.base64 = fr.result }
                    fr.readAsDataURL(this.image.object)
                }
                else {
                    this.initImage()
                }
            },

            /**
             * 状態初期化
             */
            initImage: function () {
                this.image = {
                    name: null,
                    object: null,
                    base64: null,
                };

                // 入力エリアリセット
                this.$refs.fileinput.reset()
            },

            /**
             * 画像削除の準備
             */
            prepareDeleteImage: function () {
                this.doctor.image_url = null
                this.doctor.flg_delete_image = 1
                this.initImage()
            },

            /**
             * プロフィール更新
             *
             * @param {PointerEvent} e
             */
            updateProfile: async function (e) {
                e.preventDefault()
                if (this.inProgress) return
                this.inProgress = true

                const data = this.buildFormData()
                const options = { headers: {'Content-Type': 'multipart/form-data'} }

                await axios.post(constants.doctor.profile.endpoint.base, data, options)
                    .then(({data}) => {
                        const d = data.data
                        // null代入されると以下のエラーが発生し、画面上で電話番号を変更してもpostされなくなってしまうため、nullの場合は空文字を入れる
                        // Error in getter for watcher "phoneObject.valid": "Error: Invalid phone number, expected a string"
                        d.tel = d.tel || ""
                        d.tel_national = d.tel_national || ""
                        d.tel_region = d.tel_region || ""

                        this.doctor = d
                        this.initImage()

                        if (data.summary === 'The confirm sms sent.') {
                            bus.$emit(
                                'alert-success',
                                `入力された電話番号宛に確認のショートメッセージを送信しました。もし届かない場合は${this.$locale.appName}運営までお知らせください。`,
                                10000
                            )
                        }
                        else {
                            bus.$emit('alert-success', 'プロフィールを更新しました。')
                        }
                    })
                    .catch(({response}) => {
                        if (response && response.hasOwnProperty('data') && response.data.hasOwnProperty('errors')) {
                            this.errors = response.data.errors
                            bus.$emit('alert-danger')
                        }
                        else {
                            bus.$emit('alert-danger', 'システムエラーが発生しました。')
                        }
                    })

                this.inProgress = false
            },

            /**
             * FormData作成
             *
             * @return {FormData}
             */
            buildFormData: function () {
                const formData = new FormData()

                formData.append('last_name', this.doctor.last_name)
                formData.append('first_name', this.doctor.first_name)
                formData.append('last_name_kana', this.doctor.last_name_kana)
                formData.append('first_name_kana', this.doctor.first_name_kana)
                formData.append('postcode', this.doctor.postcode || '')
                formData.append('prefecture', this.doctor.prefecture || '')
                formData.append('address', this.doctor.address || '')
                formData.append('building', this.doctor.building || '')
                formData.append('tel', this.telObj.number.e164 || '')
                formData.append('tel_national', this.telObj.number.national || '')
                formData.append('tel_region', this.telObj.regionCode || '')
                formData.append('introduction', this.doctor.introduction || '')
                formData.append('is_sms_consultation_authorized', this.doctor.doctor_metadata.is_sms_consultation_authorized == 1 ? 1 : 0)

                if (this.confTimezone == 1) {
                    formData.append('timezone', this.doctor.timezone || '')
                    formData.append('is_device_timezone', this.doctor.is_device_timezone == 1 ? 1 : 0)
                }

                if (this.image.object !== null && this.image.object !== void (0)) {
                    formData.append('profile_image', this.image.object)
                }

                if (this.doctor.flg_delete_image) {
                    formData.append('flg_delete_image', '1')
                }

                return formData
            },

            fetchTimezones: function () {
                return axios.get(constants.doctor.profile.endpoint.timezone)
                    .then(({data}) => {
                        const momentTimezones = moment.tz.names()
                        this.timezones = data.data.filter((d) => momentTimezones.includes(d.key))
                    })
            },
        },
    }
</script>

<style lang="scss">
.is-invalid {
    .custom-file-label {
        border: 1px solid #dc3545;
    }
}

.uploadImage {
    width: 100px;
}

div.input-profile-image-wrapper {
    span.form-file-text {
        color: #495057;
        font-size: 0.75rem;
        line-height: 24px;
    }
}
</style>
